import React, { useContext, useEffect, useState } from "react";
import classes from "./singlerequest.module.css";
import Aos from "aos";
import "aos/dist/aos.css";
import CustomizerContext from "../../../_helper/Customizer";




const SingleRequest = ({ id, status, date_from, employe,created_at, request,navigateShow ,t  }) => {
 const {mix_background_layout}=useContext(CustomizerContext) 

 
  useEffect(()=>{Aos.init()},[])
  useEffect(()=>{Aos.refreshHard()},[mix_background_layout])
  
  return (
    <tr>
      <td>{id}</td>
      <td>{employe}</td>
      <td>{request}</td>
      <td>{created_at}</td>
      <td>{status == 'pending' ? <span className="text-info">{t(`${status}`)}</span> : status == 'approved' ? <span className="text-success">{t(`${status}`)}</span> : <span className="text-danger">{t(`${status}`)}</span>}</td>
      <td><button className="btn btn-danger btn-sm" onClick={()=>navigateShow(id)}>{t("Show")}</button></td>
    </tr>
  );
};

export default SingleRequest;
